<template>
    <v-app-bar flat style="border-bottom:1px solid #ccc;">
      <!-- Logo and title container, direct child of v-app-bar -->
      <div class="d-flex align-center" style="height: 100%;"> 
        <img 
          :src="`/complex/${complex}/asset/emblem.jpg`" 
          class="img_logo" 
          alt="회사 로고"
        >
        <span class="text-h6 font-weight-bold ml-2">지비오</span>
      </div>

      <v-spacer></v-spacer> <!-- Pushes subsequent items to the right -->

      <!-- Navigation buttons container -->
      <div class="d-flex align-center">
        <v-btn
          v-for="(text, index) in texts"
          :key="text"
          :text="text"
          height="40"
          class="mx-2"
          variant="text"
          :to="link[index]"
        ></v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <!-- Logout button container -->
      <div style="margin-right: 16px; width:70px;">
        <v-btn icon @click="logout">
          <v-icon>mdi-logout</v-icon>
          <p class="logout-text">로그아웃</p>
        </v-btn>
      </div>
    </v-app-bar>
  </template>
  
  <script>
  export default {
    data: () => ({
      texts: ['단지현황','단지관리', '입주자관리', '공지', '민원', '에이전시', '클라이언트', '트랜잭션:광고', '트랜잭션:클라이언트'],
      link: ['/complexDetail','/', '/resident', '/noti', '/claim', '/agencyManager', '/clientManager', '/adTransaction', '/clientTransaction'],
      complex: ''
    }),
    mounted(){
      this.complex= this.getComplex();
    },  
    methods: {
      logout() {
        document.cookie.split(";").forEach(cookie => {
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          document.cookie = `${name}=; path=/; max-age=0`;
        });
        this.$router.push("/login");
      }, 

      getComplex() {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; complex=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      }
    }
  };
  </script>
  
  <style scoped>
    .img_logo {
      height: 100%; /* Set to 100% to fill parent div's height */
      width: auto;   
      object-fit: contain;
      flex-shrink: 0; 
      display: block; /* Good practice for image layout */
    }
    .logout-text {
      font-size: 0.65rem;
      line-height: 1;
      margin-top: 1px;
      text-transform: none;
    }
  </style>